import Box from 'components/shared/Box'
import styled from 'styled-components/macro'
import { respondAbove } from 'styles/mediaQueries'

export const MarchPromoInfoWrapper = styled(Box)`
    padding: 0;
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    .palm-leafs-left {
        position: absolute;
        left: 0;
        top: 6px;

        &.small-icon {
            top: 0;
        }
    }

    .palm-leafs-right {
        position: absolute;
        right: 0;
        top: 0;
    }

    .small-icon {
        display: block;
    }

    .large-icon {
        display: none;
    }

    @media ${respondAbove.xl} {
        padding: 32px 40px 30px 80px;

        .ticket-separator,
        .small-icon {
            display: none;
        }

        .large-icon {
            display: block;
        }
    }
`

export const MarchPromoContainer = styled(Box)`
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    border-radius: 8px;

    .ticket-separator-desktop {
        display: none;
    }

    @media ${respondAbove.xl} {
        .ticket-separator-desktop {
            display: block;
        }
    }
`
